<template>
    <div class="col-xs-10 col-xs-offset-1">
        <div class="row">
            <div class="form-group col-xs-6">
                <select v-model="paramsOperator" class="form-control">
                    <option value=">=">Greater Than or Equal To</option>
                    <option value=">">Greater Than</option>
                    <option value="<">Less Than</option>
                    <option value="<=">Less Than or Equal To</option>
                </select>
            </div>
            <div class="form-group col-xs-6">
                <datepicker type="number" :calendar-button="calendar" :calendar-button-icon="calendarClass" :clear-button="clear" :clear-button-icon="clearClass" :input-class="inputClass" :format="dateFormat" v-model="paramsValue"></datepicker>
            </div>
        </div>
    </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker'

    export default {
        props: ['params'],
        name: 'SearchCompareDate',
        components: {Datepicker},
        data () {
            return {
                dateFormat: 'yyyy-MM-dd',
                inputClass: 'form-control',
                calendar: true,
                clear: true,
                calendarClass: 'glyphicon glyphicon-calendar',
                clearClass: 'glyphicon glyphicon-remove'
            }
        },
        computed: {
            paramsValue: {
                get () {
                    return this.params !== null
                        ? this.params.value
                            ? this.params.value + 'T00:00:00'
                            : ''
                        : ''
                },
                set (newValue) {
                    this.$emit('update:params', {
                        value: this.$options.filters.formatDate(newValue.toISOString(), 'YYYY-MM-DD'),
                        operator: this.params.operator
                    })
                }
            },
            paramsOperator: {
                get () {
                    return this.params !== null ? this.params.operator || null : null
                },
                set (newValue) {
                    this.$emit('update:params', {
                        value: this.params.value,
                        operator: newValue
                    })
                }
            }
        },
        methods: {},
        created () {
            if (this.params === null) {
                this.$emit('update:params', {
                    value: '',
                    operator: '>='
                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// SearchCompareDate.vue?206da086